"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const services_1 = require("@zapier/services");
const labelCss = core_1.css `
  display: flex;
  flex-direction: column;
  align-items: start;
`;
const labelCssWhenSearching = core_1.css `
  display: flex;
`;
const appNameCss = core_1.css `
  color: ${design_system_1.Colors.black};
  font-size: 14px;
  margin-bottom: 3px;
`;
const appBannerCss = core_1.css `
  margin-left: 10px;
`;
const AppListItemLabel = ({ name, banner, isSearching, subtitle, }) => isSearching ? (core_1.jsx("div", null,
    core_1.jsx("div", { css: labelCssWhenSearching },
        core_1.jsx("span", { className: "app__name", css: appNameCss }, name),
        core_1.jsx("span", { css: appBannerCss },
            core_1.jsx(services_1.AppBanner, { banner: banner }))),
    subtitle && (core_1.jsx(design_system_1.Text, { color: "grey700", type: "altText800" }, subtitle)))) : (core_1.jsx("div", { css: labelCss },
    core_1.jsx("span", { className: "app__name", css: appNameCss }, name),
    core_1.jsx(services_1.AppBanner, { banner: banner }),
    subtitle && (core_1.jsx(design_system_1.Text, { color: "grey700", type: "altText800" }, subtitle))));
exports.default = AppListItemLabel;
